import {FinancialEntityType} from '../../../__generated__/generated_types';
import {Property} from '../../../contexts/properties/PropertiesContext';
import {formatterDollarUSNoDecimal, formatterPercentWithSign} from '../../../utils/formatters';
import {getMonths} from "../../../utils/months-helper";
import {IFinancialsCOATableRow} from '../components/helpers';
import {chunkArray} from './pdfExportHelpers';


function isAllZeroOrNull(values: (number | null)[]): boolean {
    return values.every(value => value === 0 || value === null);
}

export function financialTableDataToRows(property: Property, tableData: IFinancialsCOATableRow[], isUsingCustomT12: boolean, customT12Label: string): string[][][] {
    const months = getMonths(property);
    const columnHeaders = [
        "GL No.",
        "Description",
        ...months,
        `${property.isAcquisitionProperty ? property.acquisitionBudgetYear : property.budgetYear} BDGT Total`,
        isUsingCustomT12 ? `${customT12Label} Total` : `${property.reforecastYear} RFCST Total`,
        "Var $",
        "Var %",
    ];

    // we want to have different styling for different row types, and since we just send the table data as
    // an array of string arrays, I'm adding some extra info to the first row that can be read and stripped in
    // the pdfExportHelpers when we render the column
    const getFirstRowValue = (row: IFinancialsCOATableRow): string => {
        if (row.type === FinancialEntityType.Component || (row.type === FinancialEntityType.Category && row.isTopLevelAccount)) {
            return `${row.number ?? ""}__COMPONENT`;
        }

        if (row.type === FinancialEntityType.Category) {
            return `${row.number ?? ""}__CATEGORY`;
        }

        return row.number ?? "";
    };

    const rows = tableData
        .filter(row => !isAllZeroOrNull(row.budgetValues) || !isAllZeroOrNull(row.reforecastValues))
        .sortBy("order").map(row => [
            getFirstRowValue(row),
            row.name,
            ...row.budgetValues.map(val => val === null ? "-" : formatterDollarUSNoDecimal.format(val)),
            row.budgetTotal === null ? "-" : formatterDollarUSNoDecimal.format(row.budgetTotal),
            row.reforecastTotal === null ? "-" : formatterDollarUSNoDecimal.format(row.reforecastTotal),
            row.varianceAmount === null ? "-" : formatterDollarUSNoDecimal.format(row.varianceAmount),
            row.variancePercent === null ? "-" : formatterPercentWithSign.format(row.variancePercent),
    ]);

    const chunkedData = chunkArray(rows, 28).map(chunk => [columnHeaders, ...chunk]);

    return chunkedData;
}
